import { render, staticRenderFns } from "./ImportExportConsultaApi.vue?vue&type=template&id=04994ebb"
import script from "./ImportExportConsultaApi.vue?vue&type=script&lang=js"
export * from "./ImportExportConsultaApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports